import CalendariumPage from './CalendariumPage';

export default CalendariumPage;
